<template>
  <div class="container">
    <el-container>
      <el-aside class="aside" style="background-color: #545c64">
        <el-menu v-if="data.foldMenus" :unique-opened="true" active-text-color="#ffd04b" background-color="#5b6874" class="el-menu-vertical-demo" default-active="2" text-color="#fff">
          <el-sub-menu style="background-color: #545c64;" v-for="(menu, index) in data.menus" :key="menu.en" :index="index + 1 + ''" v-show="!menu.hidden">
            <template #title>
              <span>{{ util.language(menu.cn, menu.en) }}</span>
            </template>
            <el-menu-item v-for="(page, index2) in menu.pages" :index="index + '-' + index2" :key="page.path" @click="router.push('/' + page.path)">{{ util.language(page.cn, page.en) }}</el-menu-item>
          </el-sub-menu>
        </el-menu>
        <el-menu v-else active-text-color="#ffd04b" background-color="#545c64" class="el-menu-vertical-demo" default-active="2" text-color="#fff">
          <div v-for="(menu, index) in data.menus" :key="menu.en" v-show="!menu.hidden">
            <el-menu-item v-for="(page, index2) in menu.pages" :index="index + '-' + index2" :key="page.path" @click="router.push('/' + page.path)">{{ util.language(page.cn, page.en) }}</el-menu-item>
          </div>
        </el-menu>
      </el-aside>
      <el-container>
        <!-- <el-aside class="aside">
          <el-collapse accordion>
            <el-collapse-item v-for="menu in data.menus" :key="menu.label" :title="menu.label" :name="menu.label" v-show="!menu.hidden">
              <div v-for="page in menu.pages" :key="page.label">
                <el-button text @click="router.push('/' + page.path)">{{ page.label }}</el-button>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-aside> -->
        <el-header class="header" style="display: flex; justify-content: space-between;">
          <div style="display: flex; justify-content:flex-start;">
            <div style="margin-right: 20px;">
              <el-text>自主查询系统</el-text>
            </div>
          </div>
          <div style="display: flex; justify-content:flex-end;">
            <div style="margin-right: 20px;">
              <el-link @click="router.push('/my')">{{ user.nick }}</el-link>
            </div>
            <div style="margin-right: 20px;">
              <el-link @click="logout()">{{ util.language('退出', 'Logout') }}</el-link>
            </div>
          </div>
        </el-header>
        <el-main class="main">
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import api from '../apis/api'
import menusConf from '../router/menusConf'
import cache from '../utils/cache'
import util from '../utils/util'

const router = useRouter()
const user = cache.getObject(cache.keys.loginUser) || {}
const language = ref(cache.getString(cache.keys.language) || 'cn')

const data = reactive({
  menus: [],
  menuQuantity: 0,
  foldMenus: true, // 折叠菜单
})

api.get('/backend/user/getMyInfo').then(res => {
  if (res.admin) {
    data.menus = menusConf.filter(false)
  } else {
    data.menus = menusConf.filter(false, res.role.menuList)
  }
  let menuQuantity = 0
  data.menus.forEach(menu => {
    menuQuantity += menu.pages.length
  })
  data.menuQuantity = menuQuantity
})

const logout = () => {
  api.post('/backend/user/logout').then(() => {
    cache.setObject(cache.keys.loginUser, null)
    ElMessage.success(util.language('安全退出', 'Logout successfully'))
    router.push('/login')
  })
}
</script>

<style lang="less">
.container {
  .aside {
    width: 250px;
    height: 100vh;
  }

  .header {
    height: 49px;
    line-height: 49px;
    overflow: hidden;
    border-bottom: 1px solid #eee;
  }

  /deep/ .el-menu {
    background-color: #5b6874;
  }

  /deep/ .el-submenu .el-menu {
    background-color: #283847;
  }
}
</style>